/* global tinymce */

export function initHTMLEditors() {
    if ($('.html-editor').length) {
        tinymce.init({
            selector: '.html-editor',
            height: 250,
            theme: 'silver',
            plugins: [
                'advlist autolink lists link image charmap preview hr anchor pagebreak',
                'searchreplace wordcount visualblocks visualchars code fullscreen',
                'insertdatetime media nonbreaking save table directionality',
                'emoticons paste textpattern imagetools',
            ],
            toolbar:
                'insertfile undo redo | styleselect | fontselect | fontsizeselect | forecolor backcolor | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image media emoticons | preview code',
            fontsize_formats:
                '8pt 10pt 12pt 14pt 16pt 18pt 20pt 22pt 24pt 26pt 28pt 30pt 36pt',
            image_advtab: true,
            removed_menuitems: 'newdocument',
            content_css: [
                'https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css',
                (window.__PAGE_CTX__?.baseUrl || '') + '/local_assets/font-awesome/6.5.1/css/all.min.css',
                '/application/views/_common/css/styles.css',
            ],
            valid_children:
                '+body[style], +div[style], +span[style], +p[style], +h1[style], +h2[style], +h3[style], +h4[style], +h5[style], +h6[style]',
        });
    }
}
